import type { Programa } from "@/interfaces/programa.interface";
import { axiosInstance } from "@retro-ia/shared/axios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export interface ProgramasResponse {
  data: Programa[];
  total: number;
}

export interface ProgramaOption {
  id: number;
  nombre: string;
}

export const useProgramas = (page: number, limit: number, search: string) => {
  return useQuery<ProgramasResponse, Error>({
    queryKey: ["programas", page, limit, search],
    queryFn: async () => {
      const response = await axiosInstance.get("/programas", {
        params: { page, limit, search },
      });
      return response.data;
    },
    placeholderData: keepPreviousData,
  });
};

export const useProgramasOptions = (search: string, page = 1, limit = 20) => {
  return useQuery<{ data: ProgramaOption[]; total: number }, Error>({
    queryKey: ["programas-select", search, page, limit],
    queryFn: async () => {
      const res = await axiosInstance.get("/programas/select-options", {
        params: { search, page, limit },
      });
      return res.data;
    },
  });
};

export const useProgramasByClienteFinal = (idClienteFinal?: number) => {
  return useQuery<Programa[], Error>({
    queryKey: ["programasByClienteFinal", idClienteFinal],
    queryFn: async () => {
      if (!idClienteFinal) return [];
      const res = await axiosInstance.get(
        `/clientes-finales/${idClienteFinal}/programas`
      );
      return res.data;
    },
    enabled: !!idClienteFinal,
  });
};

export const useProgramaById = (id?: number) => {
  return useQuery<Programa, Error>({
    queryKey: ["programa", id],
    queryFn: async () => {
      if (!id) throw new Error("No id provided");
      const res = await axiosInstance.get(`/programas/${id}`);
      return res.data;
    },
    enabled: !!id,
  });
};
